import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  // top-row fields (4-col)
  unNumber: {
    description: 'Label for UN Number field in HAZMAT section',
    defaultMessage: 'UN Number',
    id: '6tqr6H',
  },
  naNumber: {
    description: 'Label for NA Number field in HAZMAT section (shared with dangerous goods)',
    defaultMessage: 'NA Number',
    id: 'PvSOpY',
  },
  hazardClass: {
    description: 'Label for Hazard Class dropdown in HAZMAT section',
    defaultMessage: 'Hazard Class',
    id: 'tgQyQk',
  },
  packingGroup: {
    description: 'Label for Packing Group dropdown in HAZMAT section',
    defaultMessage: 'Packing Group',
    id: 'lBpv7H',
  },
  noPackagingGroupOption: {
    description: 'Label for the "no packaging group" option in the Packing Group dropdown in HAZMAT section',
    defaultMessage: 'No Packaging Group',
    id: '6IJXkW',
  },
  // full-width
  properShippingName: {
    description: 'Label for Proper Shipping Name field in HAZMAT section',
    defaultMessage: 'Proper Shipping Name',
    id: 'x1l9NX',
  },
  // 2-col row
  ergReferenceNumber: {
    description: 'Label for ERG Reference Number field in HAZMAT section',
    defaultMessage: 'ERG Reference No.',
    id: 'LAn44j',
  },
  ergReferenceNumberTooltip: {
    description: 'Tooltip for ERG Reference Number field in HAZMAT section',
    defaultMessage: 'The Emergency Response Guidebook (ERG) reference number helps emergency responders identify the hazardous material.',
    id: '7BwDqD',
  },
  flashpointTemperatureF: {
    description: 'Label for Flashpoint Temperature field in HAZMAT section',
    defaultMessage: 'Flashpoint Temperature (F)',
    id: 'bbvjXt',
  },
  // full-width textarea
  additionalDetails: {
    description: 'Label for Additional Details textarea in HAZMAT section',
    defaultMessage: 'Additional Details',
    id: 'QjJWWi',
  },
  additionalDetailsPlaceholder: {
    description: 'Placeholder for Additional Details textarea in HAZMAT section',
    defaultMessage: 'Special handling, packaging notes, or carrier instructions...',
    id: 'RTgffp',
  },
  // section subheadings
  hazardousMaterialDetails: {
    description: 'Subheading for the hazardous material details section',
    defaultMessage: 'Hazardous material details',
    id: 'MQj6or',
  },
  emergencyContactTitle: {
    description: 'Subheading for the 24-hour emergency contact section in HAZMAT',
    defaultMessage: '24-hour emergency contact',
    id: 'AAsLLS',
  },
  emergencyContactName: {
    description: 'Label for Emergency Contact Name field in HAZMAT section',
    defaultMessage: 'Emergency Contact Name',
    id: 'pnB1jR',
  },
  emergencyContactPhone: {
    description: 'Label for Emergency Phone Number field in HAZMAT section',
    defaultMessage: 'Emergency Phone Number',
    id: 's+uX6P',
  },
  selectAnOption: {
    description: 'Default placeholder for dropdowns in HAZMAT section',
    defaultMessage: 'Select an option',
    id: 'DuJuGB',
  },
  // footer
  footerCaption: {
    description: 'Footer disclaimer in the HAZMAT section',
    defaultMessage:
      'ShipStation surfaces this flag and details to carriers but does not validate DOT classification. Ensure correct packaging and documentation for each carrier.',
    id: '3XhBMD',
  },
});
